module.exports = __webpack_public_path__ + "assets/221e715fa36481a2e82eb8adacdee928.png";


//////////////////
// WEBPACK FOOTER
// ./app/shared/assets/logo-no-sub.png
// module id = 508
// module chunks = 0